<div class="xvi-select-renderer has-custom-select" [ngClass]="class">
  <xvi-custom-select
    [options]="options | async"
    [emptyOption]="emptyOption"
    [dropdownShownItemCount]="dropdownShownItemCount"
    [(value)]="value"
    [disabled]="disabled"
    [isPositionTop]="isPositionTop"
    [placeholder]="placeholder"
    [searchable]="searchable"
    (valueChange)="finishEditing($event)"
    (focusin)="onFocusIn($event)"
    [error]="isError()"
  ></xvi-custom-select>
</div>
